var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-form",
    {
      ref: "form",
      model: {
        value: _vm.isFormValid,
        callback: function($$v) {
          _vm.isFormValid = $$v
        },
        expression: "isFormValid"
      }
    },
    [
      _c(
        "v-card",
        { staticClass: "mb-12 pt-2", attrs: { color: "white" } },
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                [
                  _c("v-autocomplete", {
                    attrs: {
                      items: _vm.formValues.reasons,
                      "item-value": "value",
                      "item-text": "text",
                      label: "Razón de acceso",
                      multiple: "",
                      rules: [_vm.rules.notEmpty()],
                      placeholder:
                        "Selecciona las razones de tu acceso a la sede de Daycohost"
                    },
                    model: {
                      value: _vm.generalInformation.accessReasons,
                      callback: function($$v) {
                        _vm.$set(_vm.generalInformation, "accessReasons", $$v)
                      },
                      expression: "generalInformation.accessReasons"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-row",
            [
              _c(
                "v-expand-transition",
                [
                  _vm.checkReasons(1)
                    ? _c(
                        "v-col",
                        [
                          _c("v-autocomplete", {
                            attrs: {
                              items: _vm.motivesFilter(1),
                              "item-value": "value",
                              "item-text": "text",
                              label:
                                "Motivos para el acceso al centro de datos",
                              multiple: "",
                              rules: [
                                _vm.rules.notEmpty(),
                                _vm.rules.specialCharacters()
                              ],
                              placeholder:
                                "Selecciona los motivos de tu acceso a la sede de Daycohost"
                            },
                            model: {
                              value:
                                _vm.generalInformation.accessMotivesDataCenter,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.generalInformation,
                                  "accessMotivesDataCenter",
                                  $$v
                                )
                              },
                              expression:
                                "generalInformation.accessMotivesDataCenter"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _c(
                "v-expand-transition",
                [
                  _vm.checkReasons(2)
                    ? _c(
                        "v-col",
                        [
                          _c("v-autocomplete", {
                            attrs: {
                              items: _vm.motivesFilter(2),
                              "item-value": "value",
                              "item-text": "text",
                              label:
                                "Motivos para los trabajos en la torre de comunicación",
                              multiple: "",
                              rules: [_vm.rules.notEmpty()],
                              placeholder:
                                "Selecciona los motivos de tu acceso a la sede de Daycohost"
                            },
                            model: {
                              value: _vm.generalInformation.accessMotivesJob,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.generalInformation,
                                  "accessMotivesJob",
                                  $$v
                                )
                              },
                              expression: "generalInformation.accessMotivesJob"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _c(
                "v-expand-transition",
                [
                  _vm.checkReasons(3)
                    ? _c(
                        "v-col",
                        [
                          _c("v-autocomplete", {
                            attrs: {
                              items: _vm.motivesFilter(3),
                              "item-value": "value",
                              "item-text": "text",
                              label: "Motivos para los cambios en servicios",
                              multiple: "",
                              rules: [_vm.rules.notEmpty()],
                              placeholder:
                                "Selecciona los motivos de tu acceso a la sede de Daycohost"
                            },
                            model: {
                              value: _vm.generalInformation.accessMotivesChange,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.generalInformation,
                                  "accessMotivesChange",
                                  $$v
                                )
                              },
                              expression:
                                "generalInformation.accessMotivesChange"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-row",
            [
              _c(
                "v-scroll-y-transition",
                [
                  _vm.requiresOtherMotiveAccess
                    ? _c(
                        "v-col",
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: "Otro motivo (especifíque)",
                              rules: [
                                _vm.rules.required(),
                                _vm.rules.fieldLength(30),
                                _vm.rules.specialCharacters()
                              ]
                            },
                            model: {
                              value:
                                _vm.generalInformation.otherMotiveDataCenter,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.generalInformation,
                                  "otherMotiveDataCenter",
                                  $$v
                                )
                              },
                              expression:
                                "generalInformation.otherMotiveDataCenter"
                            }
                          })
                        ],
                        1
                      )
                    : _vm.checkReasons(1)
                    ? _c("v-spacer")
                    : _vm._e()
                ],
                1
              ),
              _c(
                "v-scroll-y-transition",
                [
                  _vm.requiresOtherMotiveJob
                    ? _c(
                        "v-col",
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: "Otro motivo (especifíque)",
                              rules: [
                                _vm.rules.required(),
                                _vm.rules.fieldLength(30),
                                _vm.rules.specialCharacters()
                              ]
                            },
                            model: {
                              value: _vm.generalInformation.otherMotiveJob,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.generalInformation,
                                  "otherMotiveJob",
                                  $$v
                                )
                              },
                              expression: "generalInformation.otherMotiveJob"
                            }
                          })
                        ],
                        1
                      )
                    : _vm.checkReasons(2)
                    ? _c("v-spacer")
                    : _vm._e()
                ],
                1
              ),
              _c(
                "v-scroll-y-transition",
                [
                  _vm.requiresOtherMotiveChange
                    ? _c(
                        "v-col",
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: "Otro motivo (especifíque)",
                              rules: [
                                _vm.rules.required(),
                                _vm.rules.fieldLength(30),
                                _vm.rules.specialCharacters()
                              ]
                            },
                            model: {
                              value: _vm.generalInformation.otherMotiveChange,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.generalInformation,
                                  "otherMotiveChange",
                                  $$v
                                )
                              },
                              expression: "generalInformation.otherMotiveChange"
                            }
                          })
                        ],
                        1
                      )
                    : _vm.checkReasons(3)
                    ? _c("v-spacer")
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-row",
            { attrs: { align: "center" } },
            [
              _c(
                "v-col",
                { attrs: { align: "center" } },
                [
                  _c(
                    "v-card",
                    { attrs: { flat: "", "max-width": "95%", color: "white" } },
                    [
                      _c(
                        "v-row",
                        { attrs: { align: "center" } },
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "4" } },
                            [
                              _c("v-checkbox", {
                                attrs: {
                                  label: "¿El cambio es de emergencia?",
                                  color: "#60BB46"
                                },
                                on: { mouseup: _vm.restoreDateValue },
                                model: {
                                  value: _vm.radio.emergencyChange,
                                  callback: function($$v) {
                                    _vm.$set(_vm.radio, "emergencyChange", $$v)
                                  },
                                  expression: "radio.emergencyChange"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "4" } },
                            [
                              _c("v-checkbox", {
                                attrs: {
                                  label:
                                    "¿El cambio requiere interrupción del sistema?",
                                  color: "#60BB46"
                                },
                                model: {
                                  value: _vm.radio.requiresInterruption,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.radio,
                                      "requiresInterruption",
                                      $$v
                                    )
                                  },
                                  expression: "radio.requiresInterruption"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "4" } },
                            [
                              _c("v-checkbox", {
                                attrs: {
                                  label: "¿Posee una orden de servicio?",
                                  color: "#60BB46"
                                },
                                on: { mouseup: _vm.restoreOrderNumber },
                                model: {
                                  value: _vm.radio.hasOrderNumber,
                                  callback: function($$v) {
                                    _vm.$set(_vm.radio, "hasOrderNumber", $$v)
                                  },
                                  expression: "radio.hasOrderNumber"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        { attrs: { align: "end" } },
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "8" } },
                            [
                              _c(
                                "v-expand-transition",
                                [
                                  _vm.radio.emergencyChange
                                    ? _c("v-textarea", {
                                        attrs: {
                                          label:
                                            "Razón del cambio de emergencia",
                                          outlined: "",
                                          placeholder:
                                            "Descripción sobre la razón del cambio de emergencia",
                                          rows: "3",
                                          rules: [
                                            _vm.rules.required(),
                                            _vm.rules.fieldLength(65500),
                                            _vm.rules.specialCharacters()
                                          ]
                                        },
                                        model: {
                                          value:
                                            _vm.generalInformation
                                              .emergencyChangeReason,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.generalInformation,
                                              "emergencyChangeReason",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "generalInformation.emergencyChangeReason"
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "mb-2",
                              attrs: { cols: "12", sm: "4" }
                            },
                            [
                              _c(
                                "v-expand-transition",
                                [
                                  _vm.radio.hasOrderNumber
                                    ? _c("v-text-field", {
                                        attrs: {
                                          label: "Número de orden de servicio",
                                          placeholder:
                                            "Número de orden de servicio",
                                          rules: [
                                            _vm.rules.required(),
                                            _vm.rules.fieldLength(30)
                                          ]
                                        },
                                        model: {
                                          value:
                                            _vm.generalInformation.orderNumber,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.generalInformation,
                                              "orderNumber",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "generalInformation.orderNumber"
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "6" } },
                [
                  _c(
                    "v-menu",
                    {
                      attrs: {
                        "close-on-content-click": false,
                        "nudge-right": 40,
                        transition: "scale-transition",
                        "offset-y": "",
                        "max-width": "290px",
                        "min-width": "290px"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "activator",
                          fn: function(ref) {
                            var on = ref.on
                            return [
                              _c(
                                "v-text-field",
                                _vm._g(
                                  {
                                    attrs: {
                                      label: "Fecha de entrada",
                                      readonly: "",
                                      rules: [_vm.rules.required()],
                                      "prepend-icon": "mdi-calendar"
                                    },
                                    model: {
                                      value: _vm.fromDateFormatted,
                                      callback: function($$v) {
                                        _vm.fromDateFormatted = $$v
                                      },
                                      expression: "fromDateFormatted"
                                    }
                                  },
                                  on
                                )
                              )
                            ]
                          }
                        }
                      ]),
                      model: {
                        value: _vm.fromDateMenu,
                        callback: function($$v) {
                          _vm.fromDateMenu = $$v
                        },
                        expression: "fromDateMenu"
                      }
                    },
                    [
                      _c("v-date-picker", {
                        attrs: {
                          locale: "es",
                          min: _vm.minDate("from", 1),
                          max: _vm.maxDate("from"),
                          color: "#60BB46",
                          "header-color": "rgb(64,139,56)",
                          "allowed-dates": _vm.removeWeekends,
                          "no-title": ""
                        },
                        on: {
                          input: function($event) {
                            return _vm.dateInputted($event, "from")
                          }
                        },
                        model: {
                          value: _vm.generalInformation.fromDateVal,
                          callback: function($$v) {
                            _vm.$set(_vm.generalInformation, "fromDateVal", $$v)
                          },
                          expression: "generalInformation.fromDateVal"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "6" } },
                [
                  _c("v-text-field", {
                    attrs: {
                      disabled:
                        _vm.generalInformation.fromDateVal == "" ? true : false,
                      label: "Hora de entrada",
                      error: _vm.invalidTime,
                      rules: [
                        _vm.rules.required(),
                        _vm.rules.validTime(_vm.generalInformation.fromDateVal)
                      ],
                      type: "time",
                      "prepend-icon": "mdi-watch"
                    },
                    model: {
                      value: _vm.generalInformation.fromTimeVal,
                      callback: function($$v) {
                        _vm.$set(_vm.generalInformation, "fromTimeVal", $$v)
                      },
                      expression: "generalInformation.fromTimeVal"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "6" } },
                [
                  _c(
                    "v-menu",
                    {
                      attrs: {
                        "close-on-content-click": false,
                        "nudge-right": 40,
                        transition: "scale-transition",
                        "offset-y": "",
                        "max-width": "290px",
                        "min-width": "290px"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "activator",
                          fn: function(ref) {
                            var on = ref.on
                            return [
                              _c(
                                "v-text-field",
                                _vm._g(
                                  {
                                    attrs: {
                                      disabled:
                                        _vm.generalInformation.fromDateVal == ""
                                          ? true
                                          : false,
                                      label: "Fecha de salida",
                                      readonly: "",
                                      rules: [_vm.rules.required()],
                                      "prepend-icon": "mdi-calendar"
                                    },
                                    model: {
                                      value: _vm.toDateFormatted,
                                      callback: function($$v) {
                                        _vm.toDateFormatted = $$v
                                      },
                                      expression: "toDateFormatted"
                                    }
                                  },
                                  on
                                )
                              )
                            ]
                          }
                        }
                      ]),
                      model: {
                        value: _vm.toDateMenu,
                        callback: function($$v) {
                          _vm.toDateMenu = $$v
                        },
                        expression: "toDateMenu"
                      }
                    },
                    [
                      _c("v-date-picker", {
                        attrs: {
                          locale: "es",
                          min: _vm.minDate("to"),
                          max: _vm.maxDate("to", 2),
                          "show-current": _vm.generalInformation.fromDateVal,
                          "allowed-dates": _vm.removeWeekends,
                          color: "#60BB46",
                          "header-color": "rgb(64,139,56)",
                          "no-title": ""
                        },
                        on: {
                          input: function($event) {
                            return _vm.dateInputted($event, "to")
                          }
                        },
                        model: {
                          value: _vm.generalInformation.toDateVal,
                          callback: function($$v) {
                            _vm.$set(_vm.generalInformation, "toDateVal", $$v)
                          },
                          expression: "generalInformation.toDateVal"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "6" } },
                [
                  _c("v-text-field", {
                    attrs: {
                      disabled:
                        _vm.generalInformation.toDateVal == "" ? true : false,
                      label: "Hora de salida",
                      rules: [
                        _vm.rules.required(),
                        _vm.rules.timeRange(
                          _vm.generalInformation.fromDateVal,
                          _vm.generalInformation.toDateVal,
                          _vm.generalInformation.fromTimeVal
                        )
                      ],
                      type: "time",
                      "prepend-icon": "mdi-watch"
                    },
                    model: {
                      value: _vm.generalInformation.toTimeVal,
                      callback: function($$v) {
                        _vm.$set(_vm.generalInformation, "toTimeVal", $$v)
                      },
                      expression: "generalInformation.toTimeVal"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm.formValues != {}
            ? _c(
                "div",
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "v-radio-group",
                            {
                              attrs: {
                                label: "Sede a visitar",
                                rules: [_vm.rules.required()],
                                row: ""
                              },
                              model: {
                                value: _vm.generalInformation.headquarters,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.generalInformation,
                                    "headquarters",
                                    $$v
                                  )
                                },
                                expression: "generalInformation.headquarters"
                              }
                            },
                            _vm._l(_vm.formValues.dataCenters, function(
                              headquarter
                            ) {
                              return _c(
                                "div",
                                { key: headquarter.value },
                                [
                                  _c("v-radio", {
                                    attrs: {
                                      label: headquarter.text,
                                      value: headquarter.value,
                                      color: "#60BB46"
                                    }
                                  })
                                ],
                                1
                              )
                            }),
                            0
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _c(
            "v-row",
            { attrs: { align: "end" } },
            [
              _c(
                "v-col",
                [
                  _c("v-textarea", {
                    attrs: {
                      counter: "65500",
                      outlined: "",
                      label: "Resumen de la actividad a realizar",
                      hint:
                        "Resuma brevemente el objetivo de su visita al data center",
                      rules: [
                        _vm.rules.fieldMaxLength(65500),
                        _vm.rules.specialCharacters()
                      ]
                    },
                    model: {
                      value: _vm.generalInformation.additionalComment,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.generalInformation,
                          "additionalComment",
                          $$v
                        )
                      },
                      expression: "generalInformation.additionalComment"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("Form-Navigation-Buttons", {
        attrs: { "first-step": "true" },
        on: {
          validateStep: _vm.validateStep,
          reset: function($event) {
            return _vm.$router.push({ name: "tickets" })
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }